export default "./images/survio-13vEL-assets-performance-24.svg";